import React, { useState, useEffect } from 'react'
import Input from '../../../Common/ui/input'
import { Button } from '../../../Common/ui/button'
import { useForm } from 'react-hook-form'
import DropdownTextInput from '../../../Common/ui/DropdownTextInput'
import { useTranslation } from 'react-i18next'
import { useCommonStore } from '../../../Common/store/CommonStore'
import SearchableSelectInput from '../../../Common/ui/SearchableSelectInput'
import { useOnboardingStore } from '../../Onboarding/Store/OnboardingStore'
import Loading from '../../../Common/ui/Loading'
import { Avatar } from '@mui/material'
import { toast } from 'react-toastify'
import { validateAndProcessImage } from '../../../../src/lib/utils'

const Profile = () => {
    const [ currentNode, setCurrentNode ] = useState(null)
    const [ nodeData, setNodeData ] = useState(null)
    const [ originalImage, setOriginalImage ] = useState(null)
    const { t } = useTranslation()
    const { getUserDetailsByIdLoading, createOrganizationChartLoading } = useOnboardingStore()
    const createOrganizationChart = useOnboardingStore((state) => state.createOrganizationChart)
    const getUserDetailsById = useOnboardingStore((state) => state.getUserDetailsById)

    const { register, reset, formState: { errors }, control } = useForm({
        defaultValues: {
            displayName: nodeData?.displayName,
            firstName: nodeData?.firstName,
            lastName: nodeData?.lastName,
            designation: nodeData?.designation,
            level: nodeData?.level,
            department: nodeData?.department,
            emailId: nodeData?.emailId,
            phoneNumber: nodeData?.phoneNo,
            role: nodeData?.role,
            fromDate: nodeData?.fromDate,
            toDate: nodeData?.toDate,
            profilePic: nodeData?.profilePic
        }
    })

    // const profileData = `data:${nodeData?.profilePic?.contentType};base64, ${nodeData?.profilePic?.file}`
    // nodeData?.profilePic?.file !== null && localStorage.setItem('profilePic', profileData)

    const [ selectedImage, setSelectedImage ] = useState(null)
    const { departmentByOrgId, getAllDepartmentByOrgId } = useCommonStore()
    const [ depByOrgId, setDepByOrgId ] = useState([])
    const orgId = localStorage.getItem('orgId')
    const userId = localStorage.getItem('userId')
    const [ loading, setLoading ] = useState(false)

    useEffect(() => {
        const fetchChartData = async () => {
            try {
                await getUserDetailsById(userId)
                    .then((response) => {
                        if (response?.data) {
                            setNodeData(response.data)
                            const profileData = response.data?.profilePic?.file === null || response.data?.profilePic?.file === undefined ? null : `data:${response.data?.profilePic?.contentType};base64, ${response.data?.profilePic?.file}`
                            localStorage.setItem('profilePic', profileData)
                            setCurrentNode(response.data)
                            setOriginalImage(response.data.profilePic)
                        }
                    })
            } catch (error) {
                console.error('Error fetching organization chart data:', error)
            }
        }

        fetchChartData()
        getAllDepartmentByOrgId(orgId)
    }, [ userId, orgId ])

    // useEffect(() => {
    //     if (currentNode) {
    //         console.log('rese')
    //         reset({
    //             firstName: nodeData?.firstName,
    //             middleName: nodeData?.middleName,
    //             lastName: nodeData?.lastName,
    //             displayName: nodeData?.displayName,
    //             designation: nodeData?.designation,
    //             level: nodeData?.level,
    //             department: nodeData?.department,
    //             emailId: nodeData?.emailId,
    //             phoneNo: nodeData?.phoneNo,
    //             role: nodeData?.role,
    //             fromDate: nodeData?.fromDate,
    //             toDate: nodeData?.toDate,
    //             profilePic: nodeData?.profilePic
    //         })
    //     }
    // }, [ currentNode, reset ])

    const updateLocalStorage = () => {
        localStorage.setItem('userId', currentNode?.userId)
        localStorage.setItem('orgId', currentNode?.orgId)
        localStorage.setItem('userName', currentNode?.displayName)
        localStorage.setItem('userRoles', JSON?.stringify(currentNode?.role))
        localStorage.setItem('emailId', currentNode?.emailId)
        localStorage.setItem('profilePic', currentNode?.profilePic)
        localStorage.setItem('isAdmin', currentNode?.isAdmin)
        localStorage.setItem('department', currentNode?.department)
        localStorage.setItem('departmentId', currentNode?.departmentId)
    }

    useEffect(() => {
        if (departmentByOrgId?.length > 0) {
            setDepByOrgId(departmentByOrgId)
        }
    }, [ reset, departmentByOrgId ])

    const handleImageChange = (e) => {
        const file = e.target.files[0]
        validateAndProcessImage(file, setSelectedImage, setCurrentNode, t, toast)
        e.target.value = ''
    }

    const handleRemoveImage = () => {
        setSelectedImage(null)
        setCurrentNode((prevNode) => ({
            ...prevNode,
            profilePic: originalImage
        }))
    }
    const handleEditFieldsChange = (value, name) => {
        const updatedValue = typeof value?.target?.value !== 'undefined' ? value.target.value : value
        setCurrentNode(prevNode => ({
            ...prevNode,
            [name]: updatedValue
        }))
    }
    const handleSave = async () => {
        try {
            setLoading(true)
            const roleIds = currentNode?.role ? Object.keys(currentNode.role).map(Number) : []
            const chartRequest = {
                empId: currentNode?.userId,
                firstName: currentNode?.firstName,
                middleName: currentNode?.middleName || '',
                lastName: currentNode?.lastName,
                displayName: currentNode?.displayName,
                emailId: currentNode?.emailId,
                phoneNo: currentNode?.phoneNo,
                role: roleIds,
                status: currentNode?.status || 1,
                isActive: currentNode?.isActive ?? false,
                fromDate: currentNode?.fromDate || null,
                // toDate: currentNode?.toDate || null,
                atPresent: currentNode?.atPresent ?? false,
                profilePic: {
                    file: currentNode?.profilePic?.file || null,
                    contentType: currentNode?.profilePic?.contentType || null,
                    fileName: currentNode?.profilePic?.fileName || null
                },
                reportsTo: currentNode?.reportsTo || 0,
                x: currentNode?.x || 0,
                y: currentNode?.y || 0
            }

            if (currentNode?.designationId) {
                chartRequest.designationId = currentNode?.designationId
            } else if (currentNode?.designation) {
                chartRequest.designation = currentNode?.designation
            }

            if (currentNode?.departmentId) {
                chartRequest.departmentId = currentNode?.departmentId
            } else if (currentNode?.department) {
                chartRequest.department = currentNode?.department
            }

            if (currentNode?.level !== undefined) {
                chartRequest.level = currentNode?.level
            }

            const data = {
                chartRequests: [chartRequest]
            }

            const response = await createOrganizationChart(data, userId, orgId)
            if (response) {
                const fetchChartData = async () => {
                    try {
                        const response = await getUserDetailsById(userId)
                        setCurrentNode(response?.data)
                        setOriginalImage(response?.data?.profilePic)
                        updateLocalStorage()
                        setLoading(false) // Set setLoading
                        toast.success(t('Profile updated successfully'))
                    } catch (error) {
                        console.error('Error fetching organization chart data:', error)
                        toast.error(t('Failed to update profile'))
                        setLoading(false) // Set setLoading
                    }
                }
                fetchChartData()
            } else {
                console.error('Failed to update profile')
                toast.error(t('Failed to update profile'))
                setLoading(false)
            }
        } catch (error) {
            console.error('Error updating profile:', error)
            setLoading(false)
        }
    }

    const handleReset = () => {
        setCurrentNode(nodeData)
    }

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
        const date = new Date(dateString)
        return date.toLocaleDateString('en-GB', options).replace(/\//g, '/')
    }

    return (
        <div className="h-[100%]" style={{ borderColor: 'hsl(var(--primary-foreground))' }}>
            <Loading isLoading={getUserDetailsByIdLoading} />
            <div className="h-[90%] pl-12 pr-7" >
                <div className='border-b-2 overflow-auto'>
                    <p className="text-3xl font-semibold md:pd-2 pb-8 flex flex-col justify-center" style={{ color: 'hsl(var(--primary))' }}>{t('Profile')}</p>
                    <div className=" flex px-8 mb-6 items-center justify-between">
                        <div className="flex justify-center items-center space-x-4">
                            {currentNode?.profilePic?.file
                                ? <img
                                    className="w-20 h-20 rounded-full object-cover border-2 border-white shadow-md hover:scale-105 transition-transform duration-300"
                                    src={`data:${currentNode?.profilePic?.contentType};base64, ${currentNode?.profilePic?.file}`}
                                    alt="Profile Icon"
                                />
                                : <Avatar sx={{ width: 80, height: 80 }} src={currentNode?.profilePic} alt={currentNode?.displayName} />
                            }

                            <div className='space-x-4'>
                                <div className='flex px-4 gap-4 items-center justify-center mb-3'>
                                    <label className={`flex cursor-pointer ${selectedImage ? 'opacity-50 cursor-not-allowed' : ''}`}>
                                        <input type="file" accept="image/png, image/jpeg, image/jpg, image/webp" style={{ display: 'none' }} onChange={handleImageChange} disabled={!!selectedImage} />
                                        <img src={'/Common/Icon/ArrowUploadIcon.svg'} alt="Upload icon" />
                                        <span className='mt-2 ml-2 grc-label-one'>{t('Upload')}</span>
                                    </label>
                                    <div
                                        className={`flex cursor-pointer ml-5 ${!selectedImage ? 'opacity-50 cursor-not-allowed' : ''}`}
                                        onClick={selectedImage ? handleRemoveImage : null}
                                    >
                                        <img src={'/Common/Icon/DeleteIcon.svg'} alt="Remove icon" />
                                        <span className='mt-1 ml-2 grc-label-one'>{t('Remove')}</span>
                                    </div>
                                </div>
                                <div className='mt-2 grc-label-one text-[12px]'>{t('Image size should not exceed 2MB')}</div>
                            </div>
                        </div>
                        <div className="flex gap-5 px-4 items-center">
                            {currentNode?.department !== 'Administration' && <h2 className='text-2xl font-semibold' style={{ color: 'hsl(var(--primary))' }}> {t('Reports To')}: </h2>}
                            {currentNode?.department !== 'Administration' && <div className="flex items-center">
                                { currentNode?.parentProfilePic
                                    ? <img
                                        className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-md hover:scale-105 transition-transform duration-300"
                                        src={`data:${currentNode?.parentProfilePic?.contentType};base64, ${currentNode?.parentProfilePic?.file}`}
                                        alt="Profile Icon"
                                    />
                                    : <Avatar sx={{ width: 48, height: 48 }} src={currentNode?.parentProfilePic} alt="Profile"/>
                                }
                                <div className='px-5'>
                                    <div className='text-xl mb-2' style={{ fontWeight: '600', color: 'hsl(var(--primary))' }}>
                                        {currentNode?.parentName || ''}
                                    </div>
                                    <div style={{ color: 'gray' }} className='text-md'>
                                        {currentNode?.parentDesignation || ''}
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
                <div className='h-[75%] mt-3 overflow-auto px-6 py-10'>
                    <div className="grid grid-cols-3 gap-6">
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <DropdownTextInput errors={errors} control={control} required rules={{ required: t('First Name is Required') }} name='firstName' label={t('First Name')} placeholder={t('Enter First Name')} value={currentNode?.firstName || ''} onValueChange={handleEditFieldsChange}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input errors={errors} control={control} name='middleName' label={t('Middle Name')} register={register} placeholder={t('Enter Middle name')} type="text" value={currentNode?.middleName || ''} onValueChange={handleEditFieldsChange} />
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input errors={errors} control={control} required rules={{ required: t('Last Name is Required') }} name='lastName' label={t('Last Name')} register={register} placeholder={t('Enter Last name')} type="text" value={currentNode?.lastName || ''} onValueChange={handleEditFieldsChange} />
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input errors={errors} control={control} required rules={{ required: t('Display Name is Required') }} name='displayName' label={t('Display Name')} register={register} placeholder={t('Enter Display Name')} type="text" value={currentNode?.displayName || ''} onValueChange={handleEditFieldsChange} />
                        </div>
                        <div style={{ width: '100%' }} className='text-muted '>
                            <Input errors={errors} control={control} required name='designation' label={t('Designation')} register={register} placeholder={t('Enter Designation Name')} type="text" value={currentNode?.designation || t('N/A')} readOnly/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input readOnly errors={errors} control={control} name='level' label={t('Level')} register={register} placeholder={t('Enter Level')} type="number" value={currentNode?.level} />
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <SearchableSelectInput
                                errors={errors} control={control}
                                required rules={{ required: t('Department is Required') }}
                                name="department" label={t('Department')} placeholder="Search"
                                value={currentNode?.department || ''}
                                options={depByOrgId?.map((data) => {
                                    return ({ id: data?.id, value: data?.id, label: data?.name, status: data?.status })
                                })}
                                onValueChange={(value) => { handleEditFieldsChange(value, 'department') }}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input errors={errors} control={control} required
                                rules={{
                                    validate: () => {
                                        const regexEmail = /^[a-zA-Z0-9.+-_%]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                        if (!regexEmail.test(currentNode?.emailId)) {
                                            return t('Enter valid email')
                                        }
                                    },
                                    required: t('Email ID is required')
                                }}
                                name='emailId' label={t('Email ID')} register={register} placeholder={t('Enter Email ID')} type="text" value={currentNode?.emailId || ''} onValueChange={handleEditFieldsChange} userId={currentNode?.userId}/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }}>
                            <Input errors={errors} control={control} required
                                rules={{
                                    validate: (value) => {
                                        const regexPhone = /^[0-9]{10}$/
                                        if (!value) { return 'Phone number is required' } else if (!regexPhone.test(value)) { return 'Phone number must be 10 digits' }
                                    },
                                    required: 'Phone number is required'
                                }}
                                name='phoneNo'
                                label={t('Phone No')}
                                register={register}
                                placeholder={t('Enter Phone Number')}
                                type="text"
                                value={currentNode?.phoneNo || ''}
                                onValueChange={handleEditFieldsChange} />
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }} className='text-muted'>
                            <Input errors={errors} control={control} required name='role' label={t('Role')} register={register} placeholder={t('Enter Role Name')} type="text" value={currentNode?.role && Object.values(currentNode?.role)?.length > 0
                                ? Object.values(currentNode?.role).join(', ')
                                : t('N/A')} readOnly/>
                        </div>
                        <div style={{ width: '100%', marginBottom: '2%' }} className='text-muted '>
                            <Input errors={errors} control={control} required name='effectivefrom' label={t('Effective From')} register={register} placeholder={t('Enter Effective From')} type="text" value={currentNode?.fromDate ? formatDate(currentNode.fromDate) : t('N/A')} readOnly/>
                        </div>
                        {/* <div style={{ width: '100%', marginBottom: '2%' }} className='text-muted'>
                            <label className='grc-label'>{t('To')}</label>
                            <div className='my-2 border-b-2 '>{currentNode?.toDate ? formatDate(currentNode.toDate) : t('N/A')}</div>
                        </div> */}

                    </div>
                </div>
            </div>
            <div className="h-[10%] flex flex-grow justify-end space-x-4 pt-7 ml-12 mr-7 items-center border-t-2 ">
                <Button
                    variant='outline'
                    style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                    onClick={() => {
                        reset()
                        handleReset()
                        setSelectedImage(null)
                    }} >{t('Cancel')}</Button>
                <Button onClick={handleSave} disabled={loading || createOrganizationChartLoading}>
                    {loading ? t('Saving...') : t('Save')}
                </Button>
            </div>
        </div>
    )
}

export default Profile
